var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-x":"hidden !important","background-color":"#000"}},[_c('LoadingComponent',{class:[{ 'loading-container': _vm.loading }, { removeLoader: !_vm.loading }]}),_vm._v(" "),_c('AppNavbar'),_vm._v(" "),_c('nuxt',{staticStyle:{"background-color":"#000"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }